import React from 'react'
import { FooterWrapper } from '../../components/GenericFooter';
import { VertContainer } from '@vertem-core/vertice-ds';
import SkeletonButton from 'antd/es/skeleton/Button';
import MediaQuery from 'react-responsive';

const FooterPlaceholder = () => {
  return (<>
    <MediaQuery maxWidth={1085}>
      <FooterWrapper>
        <div>
          <SkeletonButton
            active
            shape="round"
            rootClassName="col padding-x-extra-small"
            style={{
              height: '25px',
              maxWidth: '100%',
              width: '102px',
              display: 'block',
              margin: '20px 0'
            }}
          />
        </div>
        <div>
          <SkeletonButton
            active
            shape="round"
            rootClassName="col padding-x-extra-small"
            style={{
              height: '15px',
              maxWidth: '100%',
              width: '102px',
              display: 'block',
              margin: '0 0 15px'
            }}
          />
        </div>
        <div>
          <SkeletonButton
            active
            shape="round"
            rootClassName="col padding-x-extra-small"
            style={{
              height: '15px',
              maxWidth: '100%',
              width: '102px',
              display: 'block',
              margin: '0 0 15px'
            }}
          />
        </div>
        <div>
          <SkeletonButton
            active
            shape="round"
            rootClassName="col padding-x-extra-small"
            style={{
              height: '15px',
              maxWidth: '100%',
              width: '102px',
              display: 'block',
              margin: '0 0 15px'
            }}
          />
        </div>
        <div>
          <SkeletonButton
            active
            shape="round"
            rootClassName="col padding-x-extra-small"
            style={{
              height: '15px',
              maxWidth: '100%',
              width: '102px',
              display: 'block',
              margin: '0 0 15px'
            }}
          />
        </div>
        <div>
          <SkeletonButton
            active
            shape="round"
            rootClassName="col padding-x-extra-small"
            style={{
              height: '15px',
              maxWidth: '100%',
              width: '102px',
              display: 'block',
              margin: '0 0 15px'
            }}
          />
        </div>
        <div>
          <SkeletonButton
            active
            shape="round"
            rootClassName="col padding-x-extra-small"
            style={{
              height: '15px',
              maxWidth: '100%',
              width: '102px',
              display: 'block',
              margin: '0 0 15px'
            }}
          />
        </div>
        <div>
          <SkeletonButton
            active
            shape="round"
            rootClassName="col padding-x-extra-small"
            style={{
              height: '15px',
              maxWidth: '100%',
              width: '100vw',
              display: 'block',
              margin: '0 0 15px'
            }}
          />
        </div>
        <div>
          <SkeletonButton
            active
            shape="round"
            rootClassName="col padding-x-extra-small"
            style={{
              height: '15px',
              maxWidth: '100%',
              width: '100vw',
              display: 'block',
              margin: '0 0 15px'
            }}
          />
        </div>
        <div>
          <SkeletonButton
            active
            shape="round"
            rootClassName="col padding-x-extra-small"
            style={{
              height: '15px',
              maxWidth: '100%',
              width: '100vw',
              display: 'block',
              margin: '0 0 15px'
            }}
          />
        </div>
      </FooterWrapper>
    </MediaQuery>
    <MediaQuery minWidth={1086}>
      <FooterWrapper>
        <VertContainer
          className="vert-box-header header-desktop-container"
          spacingX="regular"
          style={{
            boxShadow: 'none',
            height: 'auto',
            minHeight: 'initial',
          }}
        >
          <div className="header-main-content" style={{
            justifyContent: 'center',
            gap: '56px',
            padding: '30px 0'
          }}>
            <div>
              <SkeletonButton
                active
                shape="round"
                rootClassName="col padding-x-extra-small"
                style={{
                  height: '25px',
                  maxWidth: '100%',
                  width: '102px',
                  display: 'block',
                }}
              />
            </div>
            <div>
              <SkeletonButton
                active
                shape="round"
                rootClassName="col padding-x-extra-small"
                style={{
                  height: '15px',
                  maxWidth: '100%',
                  width: '102px',
                  display: 'block',
                }}
              />
            </div>
            <div>
              <SkeletonButton
                active
                shape="round"
                rootClassName="col padding-x-extra-small"
                style={{
                  height: '15px',
                  maxWidth: '100%',
                  width: '102px',
                  display: 'block',
                }}
              />
            </div>
            <div>
              <SkeletonButton
                active
                shape="round"
                rootClassName="col padding-x-extra-small"
                style={{
                  height: '15px',
                  maxWidth: '100%',
                  width: '102px',
                  display: 'block',
                }}
              />
            </div>
            <div>
              <SkeletonButton
                active
                shape="round"
                rootClassName="col padding-x-extra-small"
                style={{
                  height: '15px',
                  maxWidth: '100%',
                  width: '102px',
                  display: 'block',
                }}
              />
            </div>
            <div>
              <SkeletonButton
                active
                shape="round"
                rootClassName="col padding-x-extra-small"
                style={{
                  height: '15px',
                  maxWidth: '100%',
                  width: '102px',
                  display: 'block',
                }}
              />
            </div>
            <div>
              <SkeletonButton
                active
                shape="round"
                rootClassName="col padding-x-extra-small"
                style={{
                  height: '15px',
                  maxWidth: '100%',
                  width: '102px',
                  display: 'block',
                }}
              />
            </div>
          </div>
        </VertContainer>

        <div style={{
          margin: '100px auto 0',
          width: '40vw',
        }}>
          <SkeletonButton
            active
            shape="round"
            rootClassName="col padding-x-extra-small"
            style={{
              height: '15px',
              maxWidth: '100%',
              width: '40vw',
              display: 'block',
              margin: '0 auto',
            }}
          />
        </div>
        <div style={{
          margin: '8px auto 0',
          width: '40vw',
        }}>
          <SkeletonButton
            active
            shape="round"
            rootClassName="col padding-x-extra-small"
            style={{
              height: '15px',
              maxWidth: '100%',
              width: '40vw',
              display: 'block',
              margin: '0 auto',
            }}
          />
        </div>
        <div style={{
          margin: '8px auto',
          width: '40vw',
        }}>
          <SkeletonButton
            active
            shape="round"
            rootClassName="col padding-x-extra-small"
            style={{
              height: '15px',
              maxWidth: '100%',
              width: '40vw',
              display: 'block',
              margin: '0 auto',
            }}
          />
        </div>
      </FooterWrapper>
    </MediaQuery>
  </>)
}

export default FooterPlaceholder;
